// extracted by mini-css-extract-plugin
module.exports = {"bar":"_2OwhdqmnzCXa4Y5vuAXi7i"};